import React, { useEffect, useState } from "react";
import { List, Modal, Popconfirm, Skeleton } from "antd";
import { useLazyGetWorkOrderAssetHistoryQuery } from "../../store/services/api/work-order-api";
import {humanizeDate, humanizeEnum} from "../../utils/humanizers";
import { WorkOrderPriority, WorkOrderType } from "../../store/data/entities/work-order";
import { WorkOrderStatus } from "../../store/data/entities/work-order";
import { Button } from "antd";
import {useNavigation} from "@react-navigation/native";



interface WorkOrderAssetHistoryModalProps {
  workOrderAssetId: string;
  isOpen:boolean
  onClose: () => void;
}

export default function WorkOrderAssetHistoryModal({
  workOrderAssetId,
  isOpen,
  onClose
}: WorkOrderAssetHistoryModalProps) {
  const [getWorkOrderAssetHistory, { data, isFetching }] =
    useLazyGetWorkOrderAssetHistoryQuery();
    console.log(data, 'history data');
 const navigation = useNavigation<any>();
  useEffect(() => {
    getWorkOrderAssetHistory({ workOrderAssetId });
  }, [isOpen, workOrderAssetId, getWorkOrderAssetHistory]);

  const hasChanged = (
      current: any,
      previous: any,
      field: keyof typeof current
    ) => {
      if (!previous) return false; 
      return current?.[field] !== previous?.[field];
    };
  
    const highlightStyle: React.CSSProperties = {
      color: "#cf1322",
      fontWeight: 600,
      borderRadius: 4,
    };
  
    const renderCell = (
      field: keyof typeof item,
      value: React.ReactNode,
      current: any,
      previous: any
    ) => (
      <div
        style={{
          flex: 2,
          ...(hasChanged(current, previous, field) && highlightStyle),
        }}
      >
        {value}
      </div>
    );

  return (
    <>
            <Modal
              width="100%"
              centered
              title="Previous Updates"
              open={isOpen}
              onCancel={onClose}
              onOk={null}
              footer={null}
            >
              <Skeleton loading={isFetching} active>
                <div
                  style={{
                    display: "flex",
                    fontWeight: 600,
                    borderBottom: "1px solid #f0f0f0",
                    padding: "8px 16px",
                  }}
                >
                  <div style={{ flex: 2 }}>Updated By</div>
                  <div style={{ flex: 2 }}>Updated On</div>
                  <div style={{ flex: 2 }}>Checked Completed</div>
                  <div style={{ flex: 2 }}>QR Tagged</div>
                  <div style={{ flex: 2 }}>Follow-up Required</div>
                  <div style={{ flex: 2 }}>Log Book Entry</div>
                </div>
      
                <List
                  style={{ maxHeight: "50dvh", overflowY: "auto" }}
                  dataSource={data || []}
                  renderItem={(item, index) => {
                    const comparisonItem =
                      index < (data?.length ?? 0) - 1
                        ? data?.[index + 1]
                        : null;
                    return (
                      <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                        <div style={{ flex: 2 }}>{item.lastModifiedBy}</div>
                        <div style={{ flex: 2 }}>{humanizeDate(item.lastModifiedOn,true)}</div>
                        {renderCell("isChecksCompleted", item.isChecksCompleted ? 'Y' : 'N', item, comparisonItem)}
                        {renderCell("isQRScanned", item.isQRScanned ? 'Y' : 'N', item, comparisonItem)}
                        {renderCell("isFollowUpRequired", item.isFollowUpRequired ? 'Y' : 'N', item, comparisonItem)}
                        {renderCell("comments", item.comments, item, comparisonItem)}
                      </List.Item>
                    );
                  }}
                />
              </Skeleton>
            </Modal>
    </>
  );
}
